export default __webpack_public_path__ + "static/media/why_us.d9db7d94.png";